var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dashboard-menu-branch-root"},[(_vm.isNav('dashboard'))?_c('sidebar-item',{key:'nav-dashboard',staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('Dashboard'),
      icon: 'home',
      path: '/dashboard',
    }}}):(_vm.branch.kind === 'customLink')?_c('sidebar-item',{key:'cu-' + (_vm.branch.cid || _vm.branch.href),staticClass:"text-white",attrs:{"link":{
      name: _vm.branch.label,
      icon: _vm.branch.icon || 'link',
      path: _vm.branch.href,
    }}}):(_vm.isNav('settings') && _vm.branch.legacyBlock)?_c('dashboard-sidebar-settings-block'):(_vm.isNav('settings'))?_c('sidebar-item',{key:'nav-settings',staticClass:"text-white",attrs:{"menu":true,"link":{
      name: _vm.d.$t('Settings'),
      icon: 'circle',
    }}},_vm._l((_vm.branch.children || []),function(ch,idx){return _c('dashboard-menu-branch',{key:'set-' + idx + '-' + _vm.childKey(ch),attrs:{"branch":ch}})}),1):(_vm.isNav('stock') && _vm.d.canAccessStockModule)?_c('sidebar-item',{key:'nav-stock',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Stock')),
      icon: 'boxes',
      path: `/stock`,
    }}}):(_vm.isNav('containers') && _vm.d.canAccessStockModule)?_c('sidebar-item',{key:'nav-containers',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Containers')),
      icon: 'shipping-fast',
      path: `/containers`,
    }}}):(_vm.reportMenuItem)?_c('sidebar-item',{key:'report-' + _vm.reportMenuItem._id,staticClass:"text-white",attrs:{"link":{
      name: _vm.reportMenuItem.name,
      icon: _vm.reportMenuItem.icon || 'file-alt',
      path: `/dynamic-model/${_vm.reportMenuItem.modelName}?reportId=${_vm.reportMenuItem._id}`,
    }}}):(_vm.modelWithReports)?_c('sidebar-item',{key:_vm.modelEntity.modelName + '-with-reports',staticClass:"text-white",class:_vm.modelEntity.modelName.toLowerCase(),attrs:{"link":{
      name: _vm.menuTitle(
        _vm.modelEntity.label
          ? _vm.d.$t(_vm.modelEntity.label)
          : _vm.d.$t(_vm.modelEntity.modelName)
      ),
      icon: _vm.modelEntity.icon || 'circle',
    }}},[_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('All'),
        icon: 'list',
        path: `/dynamic-model/${_vm.modelEntity.modelName}`,
      }}}),(_vm.d.canAddDynamicModel(_vm.modelEntity.modelName) && !_vm.branch.hideAddNew)?_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Add new'),
        icon: 'plus',
        path: `/dynamic-model/${_vm.modelEntity.modelName}/add`,
      }}}):_vm._e(),_vm._l((_vm.d.getGroupFieldsInMenu(_vm.modelEntity)),function(group){return _c('sidebar-item',{key:group.modelName,staticClass:"text-white",attrs:{"link":{
        name: group.label ? _vm.d.$t(group.label) : _vm.d.$t(group.key),
        icon: 'layer-group',
        path: `/dynamic-model/${group.modelName}`,
      }}})}),_vm._l((_vm.branch.children || []),function(ch,idx){return _c('dashboard-menu-branch',{key:'ml-' + _vm.modelEntity.modelName + '-' + idx + '-' + _vm.childKey(ch),attrs:{"branch":ch}})})],2):(_vm.modelWithGroupMenu)?_c('sidebar-item',{key:_vm.modelEntity.modelName + '-with-group-menu',staticClass:"text-white",class:_vm.modelEntity.modelName.toLowerCase(),attrs:{"link":{
      name: _vm.menuTitle(
        _vm.modelEntity.label
          ? _vm.d.$t(_vm.modelEntity.label)
          : _vm.d.$t(_vm.modelEntity.modelName)
      ),
      icon: _vm.modelEntity.icon || 'circle',
    }}},[_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('All'),
        icon: 'list',
        path: `/dynamic-model/${_vm.modelEntity.modelName}`,
      }}}),(_vm.d.canAddDynamicModel(_vm.modelEntity.modelName) && !_vm.branch.hideAddNew)?_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Add new'),
        icon: 'plus',
        path: `/dynamic-model/${_vm.modelEntity.modelName}/add`,
      }}}):_vm._e(),_vm._l((_vm.d.getGroupFieldsInMenu(_vm.modelEntity)),function(group){return _c('sidebar-item',{key:group.modelName,staticClass:"text-white",attrs:{"link":{
        name: group.label ? _vm.d.$t(group.label) : _vm.d.$t(group.key),
        icon: 'layer-group',
        path: `/dynamic-model/${group.modelName}`,
      }}})}),_vm._l((_vm.branch.children || []),function(ch,idx){return _c('dashboard-menu-branch',{key:'mlg-' + _vm.modelEntity.modelName + '-' + idx + '-' + _vm.childKey(ch),attrs:{"branch":ch}})})],2):(_vm.modelDirect)?_c('sidebar-item',{key:_vm.modelEntity.modelName,staticClass:"text-white",class:_vm.modelEntity.modelName.toLowerCase(),attrs:{"link":{
      name: _vm.menuTitle(
        _vm.modelEntity.label
          ? _vm.d.$t(_vm.modelEntity.label)
          : _vm.d.$t(_vm.modelEntity.modelName)
      ),
      icon: _vm.modelEntity.icon || 'circle',
    }}},[_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('All'),
        icon: 'list',
        path: `/dynamic-model/${_vm.modelEntity.modelName}`,
      }}}),(_vm.d.canAddDynamicModel(_vm.modelEntity.modelName) && !_vm.branch.hideAddNew)?_c('sidebar-item',{staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Add new'),
        icon: 'plus',
        path: `/dynamic-model/${_vm.modelEntity.modelName}/add`,
      }}}):_vm._e(),_vm._l((_vm.branch.children || []),function(ch,idx){return _c('dashboard-menu-branch',{key:'mld-' + _vm.modelEntity.modelName + '-' + idx + '-' + _vm.childKey(ch),attrs:{"branch":ch}})})],2):(
      _vm.isNav('financial') && _vm.d.canAccessFinancialModuleWithPermissions
    )?_c('sidebar-item',{key:'nav-fin',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Finance'),
      icon: 'chart-line',
      path: `/financial`,
    }}},[(_vm.d.canAccessFinancialDashboard)?_c('sidebar-item',{key:'fin-1',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Dashboard'),
        icon: 'tachometer-alt',
        path: `/financial`,
      }}}):_vm._e(),(_vm.d.canAccessFinancialPayments)?_c('sidebar-item',{key:'fin-2',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Payments'),
        icon: 'credit-card',
        path: `/financial/payments`,
      }}}):_vm._e(),(_vm.d.canAccessFinancialExpenses)?_c('sidebar-item',{key:'fin-3',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Expenses'),
        icon: 'receipt',
        path: `/financial/expenses`,
      }}}):_vm._e(),(_vm.d.canAccessFinancialCollections)?_c('sidebar-item',{key:'fin-4',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Collections'),
        icon: 'money-bill-wave',
        path: `/financial/collects`,
      }}}):_vm._e(),(_vm.d.canAccessFinancialAccountStatement)?_c('sidebar-item',{key:'fin-5',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('Account Statement'),
        icon: 'file-invoice',
        path: `/financial/account-statement`,
      }}}):_vm._e()],1):(_vm.isNav('accounting') && _vm.d.canAccessAccountingModule)?_c('sidebar-item',{key:'nav-acc',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Accounting'),
      icon: 'book',
      path: `/accounting`,
    }}}):(_vm.isNav('dhl') && _vm.d.canAccessDHLModule)?_c('sidebar-item',{key:'nav-dhl',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('DHL Tracking'),
      icon: 'truck',
      path: `/dhl/tracking`,
    }}}):(_vm.isNav('ft_container') && _vm.d.canAccessFindTeuModule)?_c('sidebar-item',{key:'nav-ft',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Container tracking'),
      icon: 'boxes',
      path: `/ft/container-tracking`,
    }}}):(_vm.isNav('comexstats') && _vm.d.canAccessComexstatsModule)?_c('sidebar-item',{key:'nav-comex',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('comexstats.menuItem')),
      icon: _vm.d.comexstatsModuleMenuItem.icon,
      path: _vm.d.comexstatsModuleMenuItem.path,
    }}}):(_vm.isNav('history') && _vm.d.canAccessHistoryModule)?_c('sidebar-item',{key:'nav-history',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('history.menuItem')),
      icon: _vm.d.historyModuleMenuItem.icon,
      path: _vm.d.historyModuleMenuItem.path,
    }}}):(_vm.isNav('mev') && _vm.d.canAccessMevModule)?_c('sidebar-item',{key:'nav-mev',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('MEV — Causas'),
      icon: _vm.d.mevModuleMenuItem.icon,
      path: _vm.d.mevModuleMenuItem.path,
    }}}):(_vm.isNav('outlook') && _vm.d.canAccessOutlookModule)?_c('sidebar-item',{key:'nav-outlook',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('outlook.mailTitle')),
      icon: _vm.d.outlookModuleMenuItem.icon,
      path: _vm.d.outlookModuleMenuItem.path,
    }}}):(_vm.isNav('nota_comercial') && _vm.d.canAccessNotaComercialModule)?_c('sidebar-item',{key:'nav-nota-comercial',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Notas comerciales'),
      icon: _vm.d.notaComercialModuleMenuItem.icon,
      path: _vm.d.notaComercialModuleMenuItem.path,
    }}}):(_vm.isNav('alisof') && _vm.d.canAccessAlisofModule)?_c('sidebar-item',{key:'nav-alisof',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Traducciones Alisof'),
      icon: _vm.d.alisofModuleMenuItem.icon,
      path: _vm.d.alisofModuleMenuItem.path,
    }}}):(_vm.isNav('alisof_posiciones') && _vm.d.canAccessAlisofModule)?_c('sidebar-item',{key:'nav-alisof-posiciones',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Posiciones'),
      icon: _vm.d.alisofPosicionesMenuItem.icon,
      path: _vm.d.alisofPosicionesMenuItem.path,
    }}}):(_vm.isNav('bolsa_comerciales') && _vm.d.canAccessBolsaComercialesModule)?_c('sidebar-item',{key:'nav-bolsa-comerciales',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('bolsaComerciales.menuItem')),
      icon: _vm.d.bolsaComercialesModuleMenuItem.icon,
      path: _vm.d.bolsaComercialesModuleMenuItem.path,
    }}},[(_vm.d.canAccessBolsaComercialesDashboard)?_c('sidebar-item',{key:'bolsa-dashboard',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('bolsaComerciales.dashboardMenu'),
        icon: 'tachometer-alt',
        path: _vm.d.bolsaComercialesModuleMenuItem.path,
      }}}):_vm._e(),(_vm.d.canAccessBolsaComercialesSettings)?_c('sidebar-item',{key:'bolsa-settings',staticClass:"text-white",attrs:{"link":{
        name: _vm.d.$t('bolsaComerciales.settingsMenu'),
        icon: 'cog',
        path: '/bolsa-comerciales/settings',
      }}}):_vm._e()],1):(_vm.isNav('facturacion_abogados') && _vm.d.canAccessFacturacionAbogadosModule)?_c('sidebar-item',{key:'nav-fact-abog',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Facturacion abogados'),
      icon: _vm.d.facturacionAbogadosModuleMenuItem.icon,
      path: _vm.d.facturacionAbogadosModuleMenuItem.path,
    }}}):(_vm.isNav('jurisprudencia') && _vm.d.canAccessJurisprudenciaModule)?_c('sidebar-item',{key:'nav-juris',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('jurisprudencia.menuItem')),
      icon: _vm.d.jurisprudenciaModuleMenuItem.icon,
      path: _vm.d.jurisprudenciaModuleMenuItem.path,
    }}}):(_vm.isNav('agent_chat') && _vm.d.canAccessAgentChat)?_c('sidebar-item',{key:'nav-agent-chat',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('ai.agentChatTitle')),
      icon: _vm.d.agentChatMenuItem.icon,
      path: _vm.d.agentChatMenuItem.path,
    }}}):(_vm.isNav('inmobiliaria') && _vm.d.canAccessInmobiliariaModule)?_c('sidebar-item',{key:'nav-inmobiliaria',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('inmobiliaria.menuItem')),
      icon: _vm.d.inmobiliariaModuleMenuItem.icon,
      path: _vm.d.inmobiliariaModuleMenuItem.path,
    }}}):(_vm.isNav('excel_mapping') && _vm.d.canAccessExcelMappingModule)?_c('sidebar-item',{key:'nav-excel',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('excelMapping.menuItem') || 'Excel Mapping'),
      icon: 'file-excel',
      path: `/excel-mapping`,
    }}}):(_vm.isNav('websites') && _vm.d.canAccessWebsiteModule)?_c('sidebar-item',{key:'nav-web',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('websites.menuItem')),
      icon: 'language',
      path: `/websites`,
    }}}):(_vm.isNav('emails') && _vm.d.canAccessEmailModule)?_c('sidebar-item',{key:'nav-email',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('emails.title')),
      icon: 'envelope',
      path: `/emails`,
    }}}):(_vm.isNav('translations') && _vm.d.canAccessTranslationsModule)?_c('sidebar-item',{key:'nav-tr',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('translations.title')),
      icon: 'language',
      path: `/translations`,
    }}}):(_vm.isNav('support') && _vm.d.canAccessSupportModule)?_c('sidebar-item',{key:'nav-sup',staticClass:"text-white",attrs:{"link":{
      name: _vm.d.$t('Technical support'),
      icon: 'headset',
      path: _vm.d.supportUnreadMentionTicketId
        ? `/support/tickets/${_vm.d.supportUnreadMentionTicketId}`
        : `/support/tickets`,
      mentionBadge: _vm.d.supportUnreadMentions,
    }}}):(_vm.isNav('instance_builder') && _vm.d.canAccessInstanceBuilderModule)?_c('sidebar-item',{key:'nav-ib',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Instance Builder'),
      icon: 'magic',
      path: `/instance-builder`,
    }}}):(_vm.isNav('chat') && _vm.d.isChatModuleActive)?_c('sidebar-item',{key:'nav-chat',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Chat') || 'Chat'),
      icon: 'comment',
      path: `/chat`,
    }}}):(_vm.isNav('cronjobs') && _vm.d.isCronjobsModuleActive && _vm.d.isAdminRole)?_c('sidebar-item',{key:'nav-cron',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.cronjobsModuleMenuItem.name),
      icon: _vm.d.cronjobsModuleMenuItem.icon,
      path: _vm.d.cronjobsModuleMenuItem.path,
    }}}):(
      _vm.isSettings('system_config') && _vm.d.hasPermission('settings_manage')
    )?_c('sidebar-item',{key:'settings-system-config',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('System Configuration') || 'System Configuration'),
      icon: 'cog',
      path: `/settings`,
    }}}):(
      _vm.isSettings('model_reference_mapping') &&
      _vm.d.hasPermission('model-definitions.view')
    )?_c('sidebar-item',{key:'settings-model-reference-mapping',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Model Mapping'),
      icon: 'retweet',
      path: `/gotrading/model-reference-mapping`,
    }}}):(
      _vm.isSettings('model_definitions') &&
      _vm.d.hasPermission('model-definitions.view')
    )?_c('sidebar-item',{key:'settings-model-definitions',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Model Definitions'),
      icon: 'sitemap',
      path: `/model-definitions`,
    }}}):(_vm.isSettings('hook_automations') && _vm.d.isAdminRole)?_c('sidebar-item',{key:'settings-hook-automations',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Hook automations'),
      icon: 'bolt',
      path: `/hook-automations`,
    }}}):(_vm.isSettings('views') && _vm.d.hasPermission('views.view'))?_c('sidebar-item',{key:'settings-views',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Views'),
      icon: 'eye',
      path: `/views`,
    }}}):(_vm.isSettings('roles') && _vm.d.hasPermission('roles.view'))?_c('sidebar-item',{key:'settings-roles',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Roles'),
      icon: 'user',
      path: `/roles`,
    }}}):(_vm.isSettings('users') && _vm.d.canAccessUsersSettings())?_c('sidebar-item',{key:'settings-users',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Users')),
      icon: 'users',
      path: `/users`,
    }}}):(_vm.isSettings('lists') && _vm.d.hasPermission('lists.view'))?_c('sidebar-item',{key:'settings-lists',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Lists')),
      icon: 'list',
      path: `/lists`,
    }}}):(_vm.isSettings('admin_links') && _vm.d.hasPermission('views.view'))?_c('sidebar-item',{key:'settings-admin-links',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Links'),
      icon: 'link',
      path: `/gotrading/admin-links`,
    }}}):(_vm.isSettings('modules') && _vm.d.hasPermission('settings_manage') && _vm.d.isAdminRole)?_c('sidebar-item',{key:'settings-modules',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Módulos del Sistema'),
      icon: 'box',
      path: `/modules`,
    }}}):(
      _vm.isSettings('relationships') && _vm.d.hasPermission('settings_manage')
    )?_c('sidebar-item',{key:'settings-relationships',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Relaciones'),
      icon: 'link',
      path: `/relationships`,
    }}}):(
      _vm.isSettings('prompt_settings') && _vm.d.hasPermission('settings_manage')
    )?_c('sidebar-item',{key:'settings-prompt-settings',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle('Prompts IA'),
      icon: 'robot',
      path: `/gotrading/prompt-settings`,
    }}}):(_vm.isSettings('orphans') && _vm.d.isAdminRole)?_c('sidebar-item',{key:'settings-orphans',staticClass:"text-white",attrs:{"link":{
      name: _vm.menuTitle(_vm.d.$t('Orphans') || 'Orphans'),
      icon: 'unlink',
      path: `/settings/orphans`,
    }}}):(_vm.branch.kind === 'folder')?_c('sidebar-item',{key:'folder-' + _vm.branch.id,staticClass:"text-white menu-user-folder",attrs:{"menu":true,"link":{
      name: _vm.folderTitle,
      icon: _vm.branch.icon || 'folder',
    }}},_vm._l((_vm.branch.children),function(ch,idx){return _c('dashboard-menu-branch',{key:'fc-' + _vm.branch.id + '-' + idx + '-' + _vm.childKey(ch),attrs:{"branch":ch}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }